import styled from 'styled-components';
import { Button, Card, IconButton, Text } from '@perch-labs/shrike';
import { RowChild } from 'styles';

export const StyledSubHeading = styled(Text).attrs({
  tag: 'h2',
  textStyle: 'eyebrow400',
  color: 'secondary',
  margin: { top: '40px' },
  style: { padding: '16px 8px' },
})``;

export const AddDocumentButton = styled(Button).attrs({
  backgroundless: true,
})`
  color: #004037;
  width: 100%; // default to mobile

  @media (min-width: 768px) {
    // 768px is a common breakpoint for tablets and above
    width: 22%; // for desktop
  }
`;

export const SelfAttestationButton = styled(Button).attrs({
  backgroundless: true,
  margin: { top: '24px' },
})`
  color: #004037;
  width: 100%; // default to mobile

  @media (min-width: 768px) {
    // 768px is a common breakpoint for tablets and above
    width: 38%; // for desktop
  }
`;

export const DisclosureButton = styled(Button).attrs({
  backgroundless: true,
  margin: { top: '24px' },
})`
  color: #004037;
  width: 100%; // default to mobile

  @media (min-width: 768px) {
    // 768px is a common breakpoint for tablets and above
    width: 38%; // for desktop
  }
`;

export const LmiStyledRowChild = styled(RowChild).attrs({
  direction: 'column',
  style: { padding: '24px 8px' },
  alignItems: 'left',
})``;

export const CardContent = styled(Card.Content).attrs({
  style: { padding: '24px' },
})``;

export const ContractDownloadButton = styled(IconButton).attrs({
  style: { maxWidth: '32px', maxHeight: '32px' },
})``;
